var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_129_1210)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.99899 32L-1.90735e-06 28.0009L11.9995 16.0013L-1.90735e-06 4.00158L3.99899 0.00253105L20 15.9987L3.99899 32Z","fill":"current"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_129_1210"},React.createElement("rect",{"width":"20","height":"32","fill":"white"})))]);
}

ArrowRight.defaultProps = {"width":"20","height":"32","viewBox":"0 0 20 32","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
